module.exports = __webpack_public_path__ + "img/login.2578bdec.png";